<template>
  <div v-if="authenticated" class="knwoledgebase-main">
    <div class="button-container">
      <button @click="loadClicked">Load</button>
      <button @click="saveClicked">Save</button>
      <div v-if="loadedFile" style="white-space: nowrap">Loaded File : {{ loadedFile['name'] }}</div>
      <div v-if="loadedFile" style="width: 100%; display: flex; justify-content: flex-end">Last Saved : {{ lastSaved }}</div>
    </div>
    <textarea id="tinymce"></textarea>

    <div v-if="showLoadPopup" class="load-popup">
      <div class="load-container">
        <div class="title">Choose the file to load</div>
        <div class="content">
          <div class="content-container" v-for="(f, i) in files" :key="i">
            <!-- <div class="file-name" :title="f">{{ f }}</div>
            <button>Open</button> -->
            <div class="name-container" @click="folderClicked(f)">
              <div class="name">{{ f['folder'] }}</div>
              <img src="https://dsmlib.logistics.systems/Files/Icons/icons8-expand-arrow-24.png" :style="{ transform: `scaleY(${f['show'] ? -1 : 1})` }">
            </div>
            <div class="name-container container-indent" v-for="(fi, fii) in f['files']" :key="fii" :style="{ display: f['show'] ? 'flex' : 'none' }">
              <div class="name">{{ fi['name'] }}</div>
              <button @click="deleteFile(fi)" style="background-color: red; color: white">Delete</button>
              <button @click="openFile(fi)">Open</button>
            </div>
          </div>
          <div v-if="files.length <= 0" style="width: 100%; text-align: center">No available files</div>
        </div>
        <div class="footer">
          <button @click="showLoadPopup = false">Cancel</button>
        </div>
      </div>
    </div>

    <div v-if="showSavePopup" class="save-popup">
      <div class="save-container">
        <div class="title">Save File</div>
        <CheckBox title="Use Existing Folder" :isChecked.sync="useExistingFolder" @checkBoxClicked="folderOptionsClicked('existing')" />
        <Dropdown :items="files" itemKey="folder" :selectedObject.sync="selectedFolder" :isDisabled="!useExistingFolder" :isRequired="useExistingFolder"
          :errorMessage.sync="folderError" />
        <CheckBox title="Use New Folder" :isChecked.sync="useNewFolder" @checkBoxClicked="folderOptionsClicked('new')" />
        <Input placeholder="New Folder" :inputValue.sync="newFolder" :isDisabled="!useNewFolder" :isRequired="useNewFolder"
          :errorMessage.sync="newFolderError" />
        <Input placeholder="File Name (must be HTML format)" :inputValue.sync="fileName" :isRequired="true" :errorMessage.sync="fileNameError" />
        <div class="save-popup-buttons">
          <button @click="saveFileClicked(false)">Save</button>
          <button @click="showSavePopup = false" style="background-color: red; color: white">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="knwoledgebase-main">
    <div class="auth-error" v-if="authenticationError">
      You are not authorized to use this page
    </div>
    <div class="auth-container" v-else>
      <div>Please enter the secret key</div>
      <Input placeholder="Secret Key" textType="password" textAlign="center" :inputValue.sync="secretKey" :errorMessage.sync="secretKeyError" />
      <button @click="submitKey">Submit</button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';

export default {
  components: {
  },
  data: function() {
    return {
      authenticated: false,
      authenticationError: false,
      secretKey: '',
      secretKeyError: '',

      showLoadPopup: false,
      showSavePopup: false,

      files: [],

      loadedFile: null,
      fileContent: '',
      lastSaved: null,

      useExistingFolder: true,
      useNewFolder: false,

      selectedFolder: null,
      newFolder: '',
      fileName: '',

      folderError: '',
      newFolderError: '',
      fileNameError: '',

      currentUser: '',
    }
  },
  props: {
  },
  methods: {
    submitKey: async function() {
      if (!this.secretKey) {
        this.secretKeyError = 'Please enter the secret key';
        return;
      }

      let auth = (await Axios.get(`/KnowledgeBase/VerifyKey?key=${btoa(this.secretKey)}`)).data;
      if (auth) {
        this.authenticated = true;
        this.currentUser = auth;

        this.$nextTick(() => {
          tinymce.init({
            selector: '#tinymce',
            // resize: false,
            // plugins: 'print preview powerpaste casechange importcss searchreplace autolink autosave save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists checklist wordcount tinymcespellchecker a11ychecker imagetools textpattern noneditable help formatpainter permanentpen pageembed charmap mentions quickbars linkchecker emoticons advtable export',
            plugins: [
              'advlist autolink lists link image imagetools charmap print preview anchor',
              'searchreplace visualblocks code fullscreen quickbars',
              'insertdatetime media table paste code help wordcount',
            ],
            toolbar: 'save | undo redo | formatselect | ' +
              'bold italic backcolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'customDocLink | removeformat | help',
            init_instance_callback: (editor) => {
              editor.on('BeforeExecCommand', (e) => this.mceCommand(e));
            },
            setup(editor) {
              editor.ui.registry.addButton('customDocLink', {
                text: 'Insert Internal Doc Link',
                onAction: () => {
                  editor.windowManager.open({
                    title: 'Insert Internal Doc Link',
                    body: {
                      type: 'panel',
                      items: [
                        {
                          type: 'input',
                          name: 'docDirectory',
                          label: 'Document Directory'
                        },
                        {
                          type: 'input',
                          name: 'docName',
                          label: 'Document Name'
                        },
                        {
                          type: 'input',
                          name: 'text',
                          label: 'Link Text'
                        }
                      ]
                    },
                    buttons: [
                      {
                        type: 'submit',
                        text: 'Insert',
                        primary: true
                      }
                    ],
                    onSubmit: (api) => {
                      const data = api.getData();
                      const html = `<a href="#" data-doc="${data.docDirectory}/${data.docName}">${data.text}</a>`;
                      editor.insertContent(html);
                      api.close();
                    }
                  })
                }
              })
            }
          });

          tinymce.activeEditor.on('keydown', this.editorKeydown);
          tinyMCE.get('tinymce').focus();
        });
      } else {
        this.authenticationError = true;
      }
    },

    getAllFiles: async function() {
      this.files = [];
      let allFiles = (await Axios.get('/KnowledgeBase/GetFiles')).data;
      if (!allFiles) { this.files = [] }

      let folder = [...new Set(allFiles.map(f => f['directory']))];
      folder.forEach(f => {
        this.files.push({
          folder: f,
          files: allFiles.filter(af => af['directory'] == f),
          show: false
        });
      });
    },

    loadClicked: function() {
      this.showLoadPopup = true;
      this.files = [];

      this.getAllFiles();  
    },
    saveClicked: async function() {
      if (tinymce.get('tinymce').getContent()) {
        this.showSavePopup = true;
        await this.getAllFiles();

        this.useExistingFolder = true;
        this.useNewFolder = false;
        this.newFolder = '';

        if (this.loadedFile) {
          this.fileName = this.loadedFile['name'];
          this.selectedFolder = this.files.find(f => f['folder'] == this.loadedFile['directory']);
        } else {
          this.selectedFolder = null;
          this.fileName = '';
        }
      } else {
        this.$showAlert('error', 'Nothing to Save', 'File cannot be empty.');
      }
    },
    saveFileClicked: async function(close, noalert) {
      let isError = false;

      if (this.useExistingFolder && !this.selectedFolder) {
        isError = true;
        this.folderError = 'Please select your folder';
      } else if (this.useNewFolder && !this.newFolder) {
        isError = true;
        this.newFolderError = 'Please enter your folder name';
      }

      if (!this.fileName) {
        isError = true;
        this.fileNameError = 'Please enter your file name';
      } else if (!this.fileName.endsWith('.html')) {
        //force user to key in the extension so no checking required on c#
        isError = true;
        this.fileNameError = 'Please include html file extension(.html) only';
      }

      if (!isError) {
        let saveObject = {
          folder: this.selectedFolder ? this.selectedFolder['folder'] : this.newFolder,
          file: this.fileName,
          content: tinymce.get('tinymce').getContent()
        };
        await Axios.post('/KnowledgeBase/SaveContent', saveObject);
        await Axios.post('/KnowledgeBase/UpdateAudit', {
          user: this.currentUser,
          updatedAt: new Date(),
          page: `/${saveObject['folder']}/${saveObject['file']}`,
          description: 'Edited'
        });

        if (close) {
          this.fileContent = '';
          this.loadedFile = null;
          tinymce.get('tinymce').setContent('');
        } else {
          let content = (await Axios.get(`/KnowledgeBase/GetContent?folder=${saveObject['folder']}&file=${saveObject['file']}`)).data;
          this.fileContent = content;
          tinymce.get('tinymce').setContent(content);
          this.showSavePopup = false;
          this.loadedFile = {
            directory: saveObject['folder'],
            name: saveObject['file']
          }
          this.lastSaved = (await Axios.get(`/KnowledgeBase/GetLastUpdate?folder=${saveObject['folder']}&file=${saveObject['file']}`)).data;
        }

        if (!noalert) {
          this.$showAlert('success', 'File Saved', `Successfully saved ${saveObject['file']}`);
        }
      }

      tinyMCE.get('tinymce').selection.select(tinyMCE.activeEditor.getBody(), true);
      tinyMCE.get('tinymce').selection.collapse(false);
    },
    folderClicked: function(folder) {
      folder['show'] = !folder['show'];
    },
    openFile: async function(file) {
      let canCreate = this.isContentSaved();
      let unsaved = null;
      if (!canCreate['noChanges']) {
        unsaved = await this.$showAlert('warning', 'Unsaved Changes', 'There are unsaved changes, are you sure you want to create new file?', [
          { text: 'Save Changes and Load File' },
          { text: 'Cancel Changes and Load File', color: 'red', textColor: 'white' },
          { text: 'Continue Editing', color: 'gray', textColor: 'white' }
        ]);
        
        switch (unsaved) {
          case 'Save Changes and Load File':
            tinymce.get('tinymce').setContent(canCreate['currentContent']);
            if (this.loadedFile) {
              this.useNewFolder = true;
              this.useExistingFolder = false;
              this.selectedFolder = null;
              
              this.newFolder = this.loadedFile['directory'];
              this.fileName = this.loadedFile['name'];
              this.saveFileClicked(true);
            } else {
              this.saveClicked();
            }
            break;
          case 'Cancel Changes and Load File':
            this.fileContent = '';
            this.loadedFile = null;
            break;
          case 'Continue Editing':
            tinymce.get('tinymce').setContent(canCreate['currentContent']);
            break;
        }
      }

      this.showLoadPopup = false;
  
      if (unsaved != 'Continue Editing') {
        let content = (await Axios.get(`/KnowledgeBase/GetContent?folder=${file['directory']}&file=${file['name']}`)).data;
        this.fileContent = content;
        this.loadedFile = file;
        tinymce.get('tinymce').setContent(content);
        this.lastSaved = (await Axios.get(`/KnowledgeBase/GetLastUpdate?folder=${file['directory']}&file=${file['name']}`)).data;
        // this.lastSaved = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss');
      }

      tinyMCE.get('tinymce').focus();
    },
    deleteFile: async function(file) {
      var isDelete = await this.$showAlert('warning', 'Delete KnowledgeBase', `Are you sure you want to delete ${file['name']} under the ${file['directory']} folder for the knowledge base?`,
      [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'gray', textColor: 'white' }
      ]);
      
      if (isDelete == 'Delete') {
        await Axios.delete(`/KnowledgeBase/DeleteFile?folder=${file['directory']}&file=${file['name']}`);
        var openedFolders = this.files.filter(f => f['show']).map(f => f['folder']);

        await this.getAllFiles();
        openedFolders.forEach(o => {
          let folder = this.files.find(f => f['folder'] == o);
          if (folder) {
            folder['show'] = true;
          }
        });
      }
    },
    isContentSaved: function() {
      let currentContent = tinymce.get('tinymce').getContent().split('\n').join('');
      let fileContent = this.fileContent.split('\n').join('').split('\r').join('');
      if (fileContent) {
        return { noChanges: fileContent == currentContent, originalContent: fileContent, currentContent: currentContent };
      } else if (currentContent) {
        return { noChanges: false, originalContent: fileContent, currentContent: currentContent };
      } else {
        return { noChanges: true, originalContent: '', currentContent: '' };
      }
    },
    folderOptionsClicked: function(e) {
      this.folderError = '';
      this.newFolderError = '';

      if (e == 'existing' && !this.useExistingFolder) {
        this.useNewFolder = true;
      } else if (e == 'existing' && this.useExistingFolder) {
        this.useNewFolder = false;
      } else if (e == 'new' && !this.useNewFolder) {
        this.useExistingFolder = true;
      } else if (e == 'new' && this.useNewFolder) {
        this.useExistingFolder = false;
      }
    },

    mceCommand: async function(e) {
      switch (e.command) {
        case 'mceNewDocument':
          let canCreate = this.isContentSaved();
          if (canCreate['noChanges']) {
            this.fileContent = '';
            this.loadedFile = null;
          } else {
            let unsaved = await this.$showAlert('warning', 'Unsaved Changes', 'There are unsaved changes, are you sure you want to create new file?', [
              { text: 'Save Changes and Create New File' },
              { text: 'Cancel Changes and Create New File', color: 'red', textColor: 'white' },
              { text: 'Continue Editing', color: 'gray', textColor: 'white' }
            ]);
            
            switch (unsaved) {
              case 'Save Changes and Create New File':
                tinymce.get('tinymce').setContent(canCreate['currentContent']);
                if (this.loadedFile) {
                  this.useNewFolder = true;
                  this.useExistingFolder = false;
                  this.selectedFolder = null;
                  
                  this.newFolder = this.loadedFile['directory'];
                  this.fileName = this.loadedFile['name'];
                  this.saveFileClicked(true);
                } else {
                  this.saveClicked();
                }
                break;
              case 'Cancel Changes and Create New File':
                this.fileContent = '';
                this.loadedFile = null;
                break;
              case 'Continue Editing':
                tinymce.get('tinymce').setContent(canCreate['currentContent']);
                break;
            }
          }
          break;
      }
    },
    editorKeydown: function(e) {
      if (e.key.toLowerCase() == 's' && e.ctrlKey) {
        e.preventDefault();
        if (this.loadedFile) {
          this.useNewFolder = true;
          this.useExistingFolder = false;
          this.selectedFolder = null;
          
          this.newFolder = this.loadedFile['directory'];
          this.fileName = this.loadedFile['name'];
          this.saveFileClicked(null, true);
        } else {
          this.saveClicked();
        }
      }
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.knwoledgebase-main {
  height: 100%;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  font-size: 12px;

  > .button-container {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    > button {
      margin-right: 5px;
    }
  }

  > textarea {
    height: 100%;
    width: 100%;
  }

  > .load-popup, > .save-popup {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(128,128,128,0.3);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    > .load-container {
      background-color: white;
      height: 90%;
      width: 90%;
      padding: 10px;
      display: flex;
      flex-direction: column;

      > .title {
        font-weight: bold;
        width: 100%;
        text-align: center;
        margin-bottom: 5px;
      }

      > .content {
        height: 100%;
        overflow: auto;

        > .content-container {
          > .name-container {
            padding: 5px;
            border: 1px solid gray;
            margin-bottom: 5px;
            display: flex;
            align-items: center;
            font-weight: bold;
            cursor: pointer;
  
            > .name {
              width: 100%;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
  
            > button {
              margin-left: 5px;
            }

            > img {
              transition: 0.3s;
            }
          }

          > .container-indent {
            margin-left: 40px;
            font-weight: normal;
            cursor: default;
          }
        }

      }

      > .footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;

        > .button {
          width: fit-content;
        }
      }

    }
  }

  > .save-popup {
    > .save-container {
      background-color: white;
      padding: 5px;
      width: 90%;
      max-width: 400px;

      > .title {
        font-weight: bold;
        text-align: center;
        margin-bottom: 5px;
      }

      > .save-popup-buttons {
        display: flex;
        width: 100%;
        justify-content: flex-end;

        > button {
          margin-left: 5px;
        }
      }
    }
  }

  > .auth-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    > :nth-child(1) {
      font-weight: bold;
      font-size: 1.2em;
      margin-bottom: 5px;
    }
  }

  > .auth-error {
    color: red;
    font-weight: bold;
    font-size: 1.2em;
    text-align: center;
  }
}
</style>